/**
 * Tooltip helper — encapsulates Bootstrap 4/5 version branching.
 * Used by core initTooltips/disposeTooltips and the modals plugin.
 */

/**
 * Initialize (or reinitialize) all tooltips on the page or within a root element.
 * @param {HTMLElement|null} root - Optional root element to scope the query. Defaults to document.
 */
export function initTooltips(root) {
    const container = root || document;

    if (window.Smart.utils.isBootstrap4()) {
        let $tooltips = $(container).find('[data-toggle="tooltip"]');
        if (!root) $tooltips = $('[data-toggle="tooltip"]');
        $tooltips.tooltip('dispose');
        $tooltips.tooltip({
            html: true,
            boundary: 'window',
            container: 'body',
            template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        });
        return;
    }

    if (window.Smart.utils.isBootstrap5()) {
        const selector = '[data-bs-toggle="tooltip"]';
        const elements = root
            ? container.querySelectorAll(selector)
            : document.querySelectorAll(selector);

        elements.forEach(function (el) {
            const existing = bootstrap.Tooltip.getInstance(el);
            if (existing) existing.dispose();
            bootstrap.Tooltip.getOrCreateInstance(el);
        });
    }
}

/**
 * Dispose all tooltips on the page or within a root element.
 * @param {HTMLElement|null} root - Optional root element to scope the query.
 */
export function disposeTooltips(root) {
    const container = root || document;

    if (window.Smart.utils.isBootstrap4()) {
        let $tooltips = $(container).find('[data-toggle="tooltip"]');
        if (!root) $tooltips = $('[data-toggle="tooltip"]');
        $tooltips.tooltip('dispose');
        return;
    }

    if (window.Smart.utils.isBootstrap5()) {
        const selector = '[data-bs-toggle="tooltip"]';
        const elements = root
            ? container.querySelectorAll(selector)
            : document.querySelectorAll(selector);

        elements.forEach(function (el) {
            const existing = bootstrap.Tooltip.getInstance(el);
            if (existing) existing.dispose();
        });
    }
}

export default { initTooltips, disposeTooltips };
